import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";



// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field


//// for dev
// var firebaseConfig = {
//   apiKey: process.env.REACT_APP_DEV_FIREBASE_APIKEY,
//   authDomain: process.env.REACT_APP_DEV_FIREBASE_PROJECTID + ".firebaseapp.com",
//   // authDomain: process.env.REACT_APP_DEV_FIREBASE_PROJECTID + ".web.app",
//   projectId: process.env.REACT_APP_DEV_FIREBASE_PROJECTID,
//   storageBucket: process.env.REACT_APP_DEV_FIREBASE_PROJECTID + ".appspot.com",
//   messagingSenderId: "172073454149",
//   // appId: "1:297067174218:web:7fc3c4e99fe85f1ebb09b3",
//   // measurementId: "G-8W2XGK055Z"
// };


///// for deploy
var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_PROJECTID + ".firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_PROJECTID + ".appspot.com",
  messagingSenderId: "297067174218",
  appId: "1:297067174218:web:7fc3c4e99fe85f1ebb09b3",
  measurementId: "G-8W2XGK055Z"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
